import dynamic from 'next/dynamic'

export const Marquee = dynamic(() => import('./marquee'))
